export default {
  name: 'MiniStat',
  props: {
    heading: String,
    value: Number,
    inactive: Boolean
  }
};
